import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  padding: 40px;\n  border-top: solid 1px ",
        ";\n\n  > div {\n    max-width: 1200px;\n    width: 100%;\n    margin: 0 auto;\n  }\n\n  a {\n    color: ",
        ";\n  }\n\n  @media (max-width: 768px) {\n    padding: 16px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 28px;\n\n  .ant-collapse {\n    display: none;\n    border: none;\n    border-bottom: 1px solid ",
        ";\n\n    .ant-collapse-content-box {\n      padding: 0;\n    }\n\n    .ant-collapse-header {\n      border-top: 1px solid ",
        ";\n      flex-direction: row-reverse;\n\n      .ant-collapse-expand-icon {\n        padding-inline-end: 0;\n      }\n    }\n  }\n\n  .ant-collapse-header-text {\n    color: ",
        ";\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 22px;\n  }\n\n  .ant-collapse-item-active {\n    .ant-collapse-expand-icon {\n      transform: rotate(180deg);\n    }\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    .ant-collapse {\n      display: block;\n    }\n\n    li {\n      padding: 12px;\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  p {\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 16px;\n    white-space: nowrap;\n  }\n\n  ul {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  li {\n    display: flex;\n\n    p {\n      margin-bottom: 0;\n    }\n\n    button {\n      width: 124px;\n      padding: 9px 0;\n\n      font-weight: 600;\n      color: ",
        " !important;\n      border: 1px solid ",
        " !important;\n      border-radius: 6px;\n      height: 100%;\n      margin-right: 12px;\n\n      span {\n        font-size: 14px;\n      }\n    }\n\n    :first-child {\n      button {\n        color: ",
        " !important;\n      }\n    }\n\n    p {\n      font-size: 12px;\n      color: ",
        ";\n      font-weight: 400;\n      line-height: 1.5;\n    }\n  }\n\n  @media (max-width: 1200px) {\n    margin-right: 32px;\n  }\n  @media (max-width: 768px) {\n    margin-bottom: 20px;\n    margin-right: 0;\n    li {\n      padding: 0;\n\n      p {\n        margin-bottom: 0;\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  width: 100%;\n  max-width: 800px;\n  font-size: 14px;\n\n  > div {\n    width: 100%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n\n    p {\n      font-weight: 700;\n      margin-bottom: 12px;\n    }\n\n    ul {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n\n      li {\n        height: 24px;\n\n        a {\n          line-height: 22px;\n          vertical-align: sub;\n        }\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  padding-top: 24px;\n  border-top: 1px solid ",
        ";\n  display: flex;\n  justify-content: space-between;\n  @media (max-width: 768px) {\n    border-top: none;\n    padding-top: 0;\n    flex-direction: column-reverse;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  line-height: 1.5;\n\n  p {\n    font-size: 12px;\n    color: ",
        ";\n  }\n\n  .copyright {\n    font-size: 12px;\n    margin-top: 16px;\n    color: ",
        ";\n  }\n\n  .block_m {\n    display: none;\n  }\n\n  @media (max-width: 1200px) {\n    p {\n      max-width: 350px;\n    }\n\n    .block_m {\n      display: block;\n      font-size: 0;\n    }\n\n    .copyright {\n      margin-bottom: 16px;\n    }\n\n    br {\n      display: none;\n    }\n  }\n  @media (max-width: 768px) {\n    border: none;\n\n    .info {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  align-items: flex-end;\n\n  ul {\n    display: flex;\n  }\n\n  li {\n    border-right: 1px solid ",
        ";\n    padding: 0 12px;\n    font-size: 14px;\n    //line-height: 22px;\n  }\n\n  li:last-child {\n    border-right: none;\n    padding-right: 0;\n  }\n\n  .social-box {\n    display: flex;\n    gap: 12px;\n\n    a {\n      padding: 8px 12px;\n      font-size: 14px;\n      background-color: ",
        ";\n      border-radius: 6px;\n      line-height: 22px;\n      align-items: center;\n      justify-content: center;\n      display: flex;\n\n      i,\n      img {\n        margin-right: 4px;\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    align-items: flex-start;\n    div {\n      margin-bottom: 20px;\n    }\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EXTERNAL_B2B_WEBFLOW_PAGE, EXTERNAL_CAREER_PAGE, EXTERNAL_CHANNEL_TALK, EXTERNAL_COMPANY_INTRODUCE, EXTERNAL_INTRODUCE_LIBRARY, EXTERNAL_PROMOTION_AUTHOR_PAGE, EXTERNAL_PROTECTION_GUIDE, EXTERNAL_SOLVOOK_BLOG, EXTERNAL_SOLVOOK_GUIDE, INTRODUCE_PAGE, PRIVACY_PAGE, RNUMBER_PAGE, SOLVOOK_WRITE_STUDIO, TERMS_OF_REFUND_PAGE, TERMS_OF_USE_PAGE, UCI_PAGE } from "@/settings/constant";
import Link from "next/link";
import React from "react";
import styled from "styled-components";
import Icon from "@/components/icon/Icon";
import { ArrowDown, Sizes } from "@/components/icon/IconList";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Button, Collapse } from "antd";
import Image from "next/image";
import { useRouter } from "next/router";
const { Panel  } = Collapse;
const categoryLinkList = [
    {
        title: "소개",
        links: [
            {
                title: "회사 소개",
                link: EXTERNAL_COMPANY_INTRODUCE
            },
            {
                title: "서비스 소개",
                link: INTRODUCE_PAGE
            },
            {
                title: "채용",
                link: EXTERNAL_CAREER_PAGE
            }
        ]
    },
    {
        title: "솔루션",
        links: [
            {
                title: "쏠북 마켓",
                link: "/"
            },
            {
                title: "쏠북 엑스퍼트",
                link: SOLVOOK_WRITE_STUDIO
            },
            {
                title: "자료 보관함",
                link: EXTERNAL_INTRODUCE_LIBRARY
            }
        ]
    },
    {
        title: "저작권보호센터",
        links: [
            {
                title: "저작권 안내",
                link: EXTERNAL_PROTECTION_GUIDE
            },
            {
                title: "R인증",
                link: RNUMBER_PAGE
            },
            {
                title: "UCI 코드",
                link: UCI_PAGE
            }
        ]
    },
    {
        title: "문의",
        links: [
            {
                title: "사업 제휴",
                link: EXTERNAL_B2B_WEBFLOW_PAGE
            },
            {
                title: "저자 신청",
                link: EXTERNAL_PROMOTION_AUTHOR_PAGE
            }
        ]
    }
];
const policyLinkList = [
    {
        title: "서비스 이용약관",
        link: TERMS_OF_USE_PAGE
    },
    {
        title: "개인정보처리방침",
        link: PRIVACY_PAGE
    },
    {
        title: "취소/환불정책",
        link: TERMS_OF_REFUND_PAGE
    }
];
export const FooterView = (props)=>{
    const SolvookAddress = "서울 서초구 법원로4길 11-6 (서초동,스매치 서초사옥)";
    const router = useRouter();
    const year = new Date().getFullYear();
    const openBlank = (link)=>{
        return link.includes("https") ? "_blank" : "_self";
    };
    const onClickLink = (link, name)=>{
        mixpanelEvent("Footer Section Clicked", {
            buttonName: name,
            buttonUrl: link
        });
    };
    return /*#__PURE__*/ _jsx(FooterViewWrapper, {
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs(FooterTop, {
                    children: [
                        /*#__PURE__*/ _jsxs(HelpCenter, {
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    children: "고객만족센터"
                                }),
                                /*#__PURE__*/ _jsxs("ul", {
                                    children: [
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "primary",
                                                    ghost: true,
                                                    onClick: ()=>{
                                                        onClickLink(EXTERNAL_CHANNEL_TALK, "채널톡 문의");
                                                        router.push(EXTERNAL_CHANNEL_TALK);
                                                    },
                                                    children: "채널톡 문의"
                                                }),
                                                /*#__PURE__*/ _jsxs("p", {
                                                    children: [
                                                        "채널톡으로 문의하시면",
                                                        /*#__PURE__*/ _jsx("br", {}),
                                                        "가장 빠른 처리가 가능합니다."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("li", {
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "primary",
                                                    ghost: true,
                                                    onClick: ()=>{
                                                        onClickLink(EXTERNAL_SOLVOOK_GUIDE, "쏠북 이용 가이드");
                                                        router.push(EXTERNAL_SOLVOOK_GUIDE);
                                                    },
                                                    children: "쏠북 이용 가이드"
                                                }),
                                                /*#__PURE__*/ _jsx("p", {})
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(CategoryLinkList, {
                            children: categoryLinkList.map((category, idx)=>/*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            children: category.title
                                        }),
                                        /*#__PURE__*/ _jsx("ul", {
                                            children: category.links.map((linkItem, idx)=>/*#__PURE__*/ _jsx("li", {
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        onClick: ()=>onClickLink(linkItem.link, linkItem.title),
                                                        href: linkItem.link,
                                                        target: openBlank(linkItem.link),
                                                        children: linkItem.title
                                                    })
                                                }, "category-link-item-".concat(idx)))
                                        })
                                    ]
                                }, "category-link-list-".concat(idx)))
                        }),
                        /*#__PURE__*/ _jsx(Collapse, {
                            collapsible: "header",
                            ghost: true,
                            expandIcon: ()=>/*#__PURE__*/ _jsx(Icon, {
                                    icon: ArrowDown,
                                    size: Sizes.small
                                }),
                            children: categoryLinkList.map((category, idx)=>/*#__PURE__*/ _jsx(Panel, {
                                    header: category.title,
                                    children: /*#__PURE__*/ _jsx("ul", {
                                        children: category.links.map((linkItem, idx)=>/*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    onClick: ()=>onClickLink(linkItem.link, linkItem.title),
                                                    href: linkItem.link,
                                                    target: openBlank(linkItem.link),
                                                    children: linkItem.title
                                                })
                                            }, "category-link-item-".concat(idx)))
                                    })
                                }, idx))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(FooterBottom, {
                    children: [
                        /*#__PURE__*/ _jsxs(CompanyInfo, {
                            children: [
                                /*#__PURE__*/ _jsxs("p", {
                                    children: [
                                        "(주)북아이피스ㅣ대표 윤미선, 김관백 | 사업자 등록번호 493-88-01679",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "block_m",
                                            children: "|"
                                        }),
                                        " 통신판매업 신고 제2021-서울서초-0156호",
                                        " ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "block_m",
                                            children: "|"
                                        }),
                                        /*#__PURE__*/ _jsx("br", {}),
                                        " 저작권대리중개업 신고 제1496호 | 본사: ",
                                        SolvookAddress,
                                        " ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "기업부설연구소: ",
                                        SolvookAddress,
                                        " | 이메일 문의 : support@bookips.com | 전화 문의 : 02-2606-4990"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "copyright",
                                    children: "ⓒ Copyright ".concat(year, ". BookIPs All Rights Reserved.")
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(CompanyLink, {
                            children: [
                                /*#__PURE__*/ _jsx("ul", {
                                    children: policyLinkList.map((linkItem, idx)=>/*#__PURE__*/ _jsx("li", {
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: linkItem.link,
                                                target: openBlank(linkItem.link),
                                                onClick: ()=>onClickLink(linkItem.link, linkItem.title),
                                                children: linkItem.title
                                            })
                                        }, "company-link-".concat(idx)))
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "social-box",
                                    children: /*#__PURE__*/ _jsxs(Link, {
                                        passHref: true,
                                        onClick: ()=>onClickLink(EXTERNAL_SOLVOOK_BLOG, "쏠북 블로그"),
                                        href: EXTERNAL_SOLVOOK_BLOG,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            /*#__PURE__*/ _jsx(Image, {
                                                src: "/static/assets/icon_blog.svg",
                                                alt: "icon image",
                                                width: 20,
                                                height: 20
                                            }),
                                            "쏠북 블로그"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const FooterViewWrapper = styled.footer.withConfig({
    componentId: "sc-4825f39a-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.sol_gray_500);
const FooterTop = styled.div.withConfig({
    componentId: "sc-4825f39a-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.sol_gray_900);
const HelpCenter = styled.div.withConfig({
    componentId: "sc-4825f39a-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_200, (props)=>props.theme.new.colors.sol_blue_400, (props)=>props.theme.new.colors.sol_gray_500);
const CategoryLinkList = styled.div.withConfig({
    componentId: "sc-4825f39a-3"
})(_templateObject3());
const FooterBottom = styled.div.withConfig({
    componentId: "sc-4825f39a-4"
})(_templateObject4(), (props)=>props.theme.new.colors.sol_gray_100);
const CompanyInfo = styled.div.withConfig({
    componentId: "sc-4825f39a-5"
})(_templateObject5(), (props)=>props.theme.new.colors.sol_gray_500, (props)=>props.theme.new.colors.sol_gray_300);
const CompanyLink = styled.div.withConfig({
    componentId: "sc-4825f39a-6"
})(_templateObject6(), (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.sol_gray_50);
